import { useContext } from 'react';

import type { ConsentContextValue } from './consent-context';

import { ConsentContext } from './consent-context';

/**
 * Consent state for the current visitor. Throws outside `ConsentProvider` —
 * a component silently falling back to "no consent" would be indistinguishable
 * from a real opt-out.
 */
export function useConsent(): ConsentContextValue {
  const value = useContext(ConsentContext);
  if (!value) {
    throw new Error('useConsent must be used within a ConsentProvider');
  }
  return value;
}
